import { useState } from 'react';

const JOB_TEMPLATES = {
    fit_template: {
        operation: "job_param",
        payload: {
            job_type: "fit",
            df_path: "df.csv",
            future_df_path: "future_df.csv",
            saturation_df_path: "saturation_df.csv",
            kpi_col: "sales",
            date_col: "date",
            resource_cols: ["promo", "radio", "search", "social", "tv"],
            event_cols: [      
                "new-years-day",
                "martin-luther-king-jr-day",
                "washingtons-birthday",
                "memorial-day",
                "independence-day",
                "labor-day",
                "columbus-day",
                "veterans-day",
                "thanksgiving-day",
                "christmas-day",
                "independence-day-observed",
                "juneteenth-national-independence-day-observed",
                "juneteenth-national-independence-day",
                "christmas-day-observed",
                "new-years-day-observed"
            ],
            model_name: "model.pkl",
            fit_args: {
                num_warmup: 250,
                num_samples: 125,
                num_chains: 8
            },
        }
    },
    attr_template: {
        operation: "job_param",
        payload: {
            job_type: "attribute",
            model_snapshot_file: "model.pkl",
            run_tag: "test_run_v1",
            attr_start: "2024-03-11",
            attr_end: "2024-04-10"
        }
    },
    target_max_template: {
        operation: "job_param",
        payload: {
            job_type: "target_max",
            model_snapshot_file: "model.pkl",
            run_tag: "test_run_v1",
            budget_start_date: "2024-03-11",
            budget_end_date: "2024-04-10",
            variants: [
                {lb: 1.0, ub: 1.0},
                { lb: 1.0, ub: 1.1 },
                { lb: 1.0, ub: 1.2 },
            ]
        }
    }
};

export const useJobParameters = () => {
    const [selectedTemplate, setSelectedTemplate] = useState('fit_template');
    const [jobParam, setJobParam] = useState(() =>
        JSON.stringify(JOB_TEMPLATES['fit_template'], null, 2)
    );

    const handleTemplateChange = (event) => {
        const selected = event.target.value;
        setSelectedTemplate(selected);
        setJobParam(JSON.stringify(JOB_TEMPLATES[selected], null, 2));
    };

    const beautifyJobParam = () => {
        try {
            const beautified = JSON.stringify(JSON.parse(jobParam), null, 2);
            setJobParam(beautified);
        } catch (err) {
            alert("Invalid JSON format!");
        }
    };

    const submitJob = async (callApi) => {
        if (!jobParam) {
            alert("Blank job param!");
            return;
        }

        const confirmed = window.confirm(`Submit this job?\n\n${jobParam}`);
        if (!confirmed) return;

        try {
            const responseBody = await callApi({
                path: '/ts-service-main',
                method: 'POST',
                body: JSON.parse(jobParam),
                contentType: 'application/json',
            });
            alert(`Job submission response:\n\n${responseBody.message}`);
        } catch (err) {
            console.error('Job submission error:', err);
            alert(`Job submission failed.\n\n${err.message}\n\nCheck console for further details.`);
        }
    };

    return {
        selectedTemplate,
        jobParam,
        setJobParam,
        handleTemplateChange,
        beautifyJobParam,
        submitJob
    };
};
